import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';

export interface IBaseContextMenuData {
	loading: boolean;
}

export interface IContextMenuData extends IBaseContextMenuData {}

export interface IReadonlyContextMenuData extends IBaseContextMenuData {}

export type ContextMenuData = ReadonlyRecord<IReadonlyContextMenuData>;

export const ContextMenuDataFactory = Record<IReadonlyContextMenuData>({
	loading: false
});

export const ContextMenuDataFactoryFromJS = function (state: IContextMenuData) {
	return ContextMenuDataFactory({
		...state
	});
};
